import React, { useEffect, useState, Fragment } from 'react';
import { Clock } from 'lucide-react';
function getTimeUntilMidnight() {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  const diff = Math.max(0, midnight.getTime() - now.getTime());
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
const pad = (n: number) => n.toString().padStart(2, '0');
export const Countdown = () => {
  const [time, setTime] = useState(getTimeUntilMidnight());
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTimeUntilMidnight());
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const units = [{
    label: 'Horas',
    value: time.hours
  }, {
    label: 'Min',
    value: time.minutes
  }, {
    label: 'Seg',
    value: time.seconds
  }];
  return <div className="bg-red-600 text-white rounded-xl px-4 py-3 shadow-lg" data-id="element-31">
      <p className="text-[11px] md:text-sm font-bold uppercase tracking-wider flex items-center justify-center gap-2 mb-2 animate-pulse text-center" data-id="element-32">
        <Clock className="w-4 h-4 flex-shrink-0" data-id="element-33" />
        ÚLTIMAS HORAS DE OFERTA
      </p>
      <div className="flex items-center justify-center gap-2" data-id="element-34">
        {units.map((unit, idx) => <Fragment key={unit.label} data-id="element-35">
            <div className="flex flex-col items-center" data-id="element-36">
              <span className="bg-white/15 rounded-lg px-2.5 py-1.5 text-xl md:text-2xl font-black tabular-nums leading-none min-w-[2.5rem] text-center" data-id="element-37">
                {pad(unit.value)}
              </span>
              <span className="text-[9px] md:text-[11px] font-semibold uppercase mt-1 tracking-wide text-white/80" data-id="element-38">
                {unit.label}
              </span>
            </div>
            {idx < units.length - 1 && <span className="text-xl md:text-2xl font-black -mt-3 text-white/60" data-id="element-39">
                :
              </span>}
          </Fragment>)}
      </div>
    </div>;
};